import { AuthProvider } from "@/hooks/useAuth";
import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import App from "./App.tsx";
import "./i18n";
import "./index.css";

// Loading component for Suspense fallback
const Loading = () => (
  <div className="flex h-screen items-center justify-center bg-primary-50 dark:bg-gray-900">
    <div className="flex flex-col items-center justify-center space-y-4">
      <div className="h-16 w-16 animate-pulse-slow rounded-full bg-primary-500"></div>
      <h1 className="text-2xl font-bold text-primary-800 dark:text-primary-200">
        Gnzabe
      </h1>
    </div>
  </div>
);

// Create router with future flags
const router = createBrowserRouter(
  [
    {
      path: "*",
      element: (
        <AuthProvider>
          <App />
        </AuthProvider>
      ),
    },
  ],
  {
    future: {
      v7_relativeSplatPath: true,
    },
  }
);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Suspense fallback={<Loading />}>
      <RouterProvider router={router} />
    </Suspense>
  </React.StrictMode>
);
